import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f44b37f2")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("textarea", {
    class: "w-full input-area",
    id: "w3review",
    name: "w3review",
    rows: "4",
    cols: "50",
    placeholder: _ctx.placeholder,
    value: _ctx.modelValue,
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
  }, null, 40, ["placeholder", "value"]))
})